import { useEffect, useState, useCallback } from "react";
import { rpc } from "@/lib/supabase";
import { PageHeader, Loader } from "@/components/kit";
import { AdminTable } from "@/components/AdminTable";
import { StatusBadge } from "@/components/StatusBadge";
import { formatCOP, formatDateTime, VEHICLE_LABELS } from "@/lib/format";

export default function AdminServices() {
  const [rows, setRows] = useState(null);
  const load = useCallback(() => {
    rpc("admin_get_services").then((d) => setRows(d || [])).catch(() => setRows([]));
  }, []);
  useEffect(() => {
    load();
    const t = setInterval(load, 12000);
    return () => clearInterval(t);
  }, [load]);
  if (rows === null) return <Loader />;

  const columns = [
    { key: "id", label: "ID", render: (r) => <span className="font-mono text-xs">#{r.id.slice(0, 8)}</span> },
    { key: "status", label: "Estado", render: (r) => <StatusBadge status={r.status} /> },
    { key: "route", label: "Ruta", render: (r) => (
        <div className="max-w-[240px]">
          <div className="truncate text-white">{r.pickup_address}</div>
          <div className="truncate text-xs text-gray-500">→ {r.dropoff_address}</div>
        </div>
      ) },
    { key: "business_name", label: "Negocio", render: (r) => r.business_name || r.business_owner || "—" },
    { key: "driver_name", label: "Conductor", render: (r) => r.driver_name || "—" },
    { key: "vehicle_type", label: "Vehículo", render: (r) => VEHICLE_LABELS[r.vehicle_type] },
    { key: "quoted_price", label: "Precio", render: (r) => <span className="font-semibold text-[#FF6A00]">{formatCOP(r.quoted_price)}</span> },
    { key: "created_at", label: "Creado", render: (r) => <span className="text-xs">{formatDateTime(r.created_at)}</span> },
  ];

  return (
    <div>
      <PageHeader title="Servicios" subtitle="Todos los envíos de la plataforma." testId="admin-services" />
      <AdminTable columns={columns} rows={rows} testId="admin-services-table" empty="No hay servicios" />
    </div>
  );
}
